module.exports = new __parcel__URL__("jetbrains-youtrack-logomark.c4874903.svg").toString();